import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	ViewRef
}
from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// RXJS
import { BehaviorSubject, ReplaySubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { DeNghiNhapKhoService } from '../kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet } from '../kho-de-nghi-nhap-kho-page-model/kho-de-nghi-nhap-kho-page.model';
import { DNNKLSNhapKhoDialogComponent } from '../kho-lich-su-nhap-list-dialog/kho-lich-su-nhap-list-dialog.component';

@Component({
	selector: 'm-kho-de-nghi-nhap-kho-detail-dialog',
	templateUrl: './kho-de-nghi-nhap-kho-detail-dialog.component.html',
	styleUrls: ['../kho-de-nghi-nhap-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class DeNghiNhapKhoDetailDialogComponent implements OnInit {


	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/


	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Solo',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'Soluongchungtu',
			displayName: 'SL',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'TenDVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SoLuongThucNhap',
			displayName: 'SL thực nhập',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'SoMay',
			displayName: 'Số máy',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'MaThung',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'XacThucPallet',
            displayName: 'Xác thực pallet',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgayDongThung',
            displayName: 'Ngày đóng thùng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'ExpiryDate',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'NgayNhanHang',
            displayName: 'Ngày nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPOKH',
            displayName: 'Số PO KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPONCC',
            displayName: 'Số PO NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'NCC',
            displayName: 'NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'Ghichulohang',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'TenNguoiKiemTra',
			displayName: 'Người duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'Ngaykiemtra',
			displayName: 'Ngày duyệt',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'Quyetdinhlohang',
			displayName: 'Kết quả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'GhiChuKetQuaKiemTra',
			displayName: 'Lý do',
			alwaysChecked: false,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách phòng ban -----------------------*/
	listPB: any[] = [];
	PBUser: string = '';
	selectPB: string = '';
	filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PBFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách bộ phận ----------------------*/
	listBP: any[] = [];
	selectBP: string = '';
	filteredBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	BPFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*--------------------- Danh sách Khu vực sản xuất -------------------*/
	listKVSX: any[] = [];
	selectKVSX: string = '';
	filteredKVSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KVSXFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách loại phiếu ----------------------*/
	listLoaiPhieu: any[] = [];
	selectLoaiPhieu: string = '';
	filteredLoaiPhieu: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiPhieuFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------ Danh sách giai đoạn hàng hóa---------------------*/
	listGDHH: any[] = [];
	selectGDHH: string = '';
	filteredGDHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	GDHHFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* ------------------- Các form trên dialog --------------------------*/
	DNNKForm: FormGroup;				     //Form thông tin đề nghị nhập kho
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	DNNKItem: DeNghiNhapKho;
	listChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	tmpChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	flagTab: number = 0;				// Định danh tab đang chạy
	optionsTinhTrang = [];
	optionsLoaiPhieu = [];
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<DeNghiNhapKhoDetailDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChungService: DungChungService,
		private deNghiNhapKhoService: DeNghiNhapKhoService,
		private DNNKFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load all dropdown and create form */
		this.ListId_HH();
		this.ListState();
		this.ListLoaiPhieu();
		this.ListPB();
		this.ListBoPhan();
		this.ListGDHH();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.optionsTinhTrang = DeNghiNhapKho.optionsTinhTrang;
		this.optionsLoaiPhieu = DeNghiNhapKho.optionsLoaiPhieu;
		this.DNNKItem = new DeNghiNhapKho();
		this.DNNKItem.clear();
		this.DNNKItem = this.data.data;
		this.createForm();
		this.bindingValueAfterCallAPIDetail();
		this.title = this.getTitle();
		this.showColumnsInTable();
		this.applySelectedColumns();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetectView();
		});

	}
	/* -----------------------------------------------------------------------*/

	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.DNNKItem.Nguoitao = +idUser;

		/*Group các Form */
		this.DNNKForm = this.DNNKFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState],
			LoaiPhieu: ['', Validators.required],
			PBDeNghi: [this.PBUser.toString(), Validators.required],
			NgayNhapKho: [new Date(), Validators.required],
			BPNhap: [''],
			PBNhap: [''],
			KhuVuc: [''],
			GiaiDoanHH: [''],
			Lydonhap: [''],
			LyDo: [''],
			ChungTuKemTheo: [false],
			SoChungTu: [''],
			MaKhachHang: [''],
			TenKhachHang: [''],
		});

		if (this.listState.length > 0) {
			this.checkState();
		}

		/*Disable các trường dữ liệu không thay đổi */
		this.DNNKForm.disable();
		/*------------------------------------------------------------------*/

		this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail() {
		if (this.DNNKItem.IdDn > 0) {

			/*Get name of người lập phiếu */
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

			var idUser = '';
			this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

			this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
			this.DNNKForm.controls["NgayLapPhieu"].setValue(this.DNNKItem.Ngaytao);
			this.DNNKForm.controls["TenNguoiLap"].setValue(this.DNNKItem.TenNguoitao);
			this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
			this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
			this.DNNKForm.controls["PBDeNghi"].setValue(this.DNNKItem.TenBoPhanDeNghi != null ? this.DNNKItem.TenBoPhanDeNghi.toString(): '');
			this.DNNKForm.controls["PBNhap"].setValue(this.DNNKItem.TenPhongBanNhap != null ? this.DNNKItem.TenPhongBanNhap.toString(): '');
			this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.TenBoPhanNhap != null ? this.DNNKItem.TenBoPhanNhap.toString(): '');
			this.DNNKForm.controls["KhuVuc"].setValue(this.DNNKItem.KhuVucSanXuat_Id != null ? this.DNNKItem.KhuVucSanXuat_Id.toString() : '');
			this.DNNKForm.controls["GiaiDoanHH"].setValue(this.DNNKItem.QTSX_GiaiDoan_Id != null ? this.DNNKItem.QTSX_GiaiDoan_Id.toString() : '');
			this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
			this.DNNKForm.controls["LyDo"].setValue(this.DNNKItem.LyDo);

			this.DNNKForm.controls["MaKhachHang"].setValue(this.DNNKItem.MaKhachHang);
			this.DNNKForm.controls["TenKhachHang"].setValue(this.DNNKItem.TenKhachHang);
			this.checkState();
			//this.checkPB();

			/*Add dữ liệu chi tiết*/
			if (this.DNNKItem.listChiTietNhapKho.length > 0) {
				this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
				this.tmpChiTietDNNK = [];

				for (let i = 0; i < this.listChiTietDNNK.length; i++) {
					if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
						this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
					}

					let tmpElement = new DeNghiNhapKhoChiTiet();
					tmpElement.copy(this.listChiTietDNNK[i]);

					this.tmpChiTietDNNK.push(tmpElement);
				}

				this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
			}
		}
	}
	getTitle(): string {
		return `Chi tiết phiếu đề nghị nhập kho`;
	}
	isLoaiPhieuHTVTKH(){
		let value = +this.DNNKForm.controls["LoaiPhieu"].value;
		let item = this.listLoaiPhieu.find(x => x.Id == value)
		if(item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value;
		return false;
	}
	/* -----------------------------------------------------------------------*/

	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	getNumOfCanSelected() {
		var count = 0;
		this.tmpChiTietDNNK.forEach(x => {
			if (x.Quyetdinhlohang == 0 && x.KetQuaDuyet != 1) {
				count++;
			}
		})
		return count;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.getNumOfCanSelected();
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietDNNK.forEach(row => {
				if (row.Quyetdinhlohang == 0 && row.KetQuaDuyet != 1) {
					this.selection.select(row)
				}
			});
		}
	}
	/* -----------------------------------------------------------------------*/
	isSelectedCoChungTu(){
		let form  = this.DNNKForm.controls;
		let value = form["ChungTuKemTheo"].value;
		return value ;
	}
	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState() {
		this.dungChungService.listState(DeNghiNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.DNNKItem.Tinhtrang) {
				this.nameState = element.Description;
				if (this.DNNKForm != null)
					this.DNNKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListId_HH() {
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}

	ListPB() {
		this.dungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPB = res.data;
				this.filteredPB.next(this.listPB.slice());

				var phongban = '';
				this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

				if (this.DNNKItem.IdDn > 0) {
					this.listPB.forEach(element => {
						if (element.Id_PB == +this.DNNKItem.BoPhanDeNghi) {
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				else {
					this.listPB.forEach(element => {
						if (element.Id_PB == +phongban) {
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				//this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
				this.changeDetectView();
			};
		});
	}
	filterPB() {
		if (!this.listPB) {
			return;
		}
		let search = this.PBFilterCtrl;
		if (!search) {
			this.filteredPB.next(this.listPB.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredPB.next(
			this.listPB.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	checkPB() {
		this.listPB.forEach(element => {
			if (element.Id_PB == this.DNNKItem.BoPhanDeNghi) {
				this.PBUser = element.Id_PB.toString();
				if (this.DNNKForm != null)
					this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
			}
		});
	}

	ListBoPhan() {
		this.dungChungService.listBoPhanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBP = res.data;
				this.filteredBP.next(this.listBP.slice());
				this.changeDetectView();
			};
		});
	}
	filterBoPhan() {
		if (!this.listBP) {
			return;
		}
		let search = this.BPFilterCtrl;
		if (!search) {
			this.filteredBP.next(this.listBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredBP.next(
			this.listBP.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListKVSXTheoBP(idBoPhan: any) {
		this.dungChungService.listKhuVucSanXuatTheoBoPhan(idBoPhan).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKVSX = res.data;
				this.filteredKVSX.next(this.listKVSX.slice());
				this.changeDetectView();
			};
		});
	}
	filterKVSXTheoBP() {
		if (!this.listKVSX) {
			return;
		}
		let search = this.KVSXFilterCtrl;
		if (!search) {
			this.filteredKVSX.next(this.listKVSX.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKVSX.next(
			this.listKVSX.filter(ts =>
				ts.TenKhuVuc.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListGDHH() {
		this.dungChungService.listGiaiDoanHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listGDHH = res.data;
				this.filteredGDHH.next(this.listGDHH.slice());
				this.changeDetectView();
			};
		});
	}
	filterGDHH() {
		if (!this.listGDHH) {
			return;
		}
		let search = this.GDHHFilterCtrl;
		if (!search) {
			this.filteredGDHH.next(this.listGDHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredGDHH.next(
			this.listGDHH.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListLoaiPhieu() {
		this.dungChungService.layDanhSachLoaiPhieu(DeNghiNhapKho.DEFAULT_LOAIPHIEU).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {

				this.listLoaiPhieu = res.data;
				this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());

				let item = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
				if (this.DNNKItem.IdDn > 0) {
					item = this.listLoaiPhieu.find(x => x.Id == this.DNNKItem.LoaiPhieu)
				}

				if (item != null && this.DNNKForm != null) {
					this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
				}

				this.changeDetectView();
			};
		});
	}
	filterLoaiPhieu() {
		if (!this.listLoaiPhieu) {
			return;
		}
		let search = this.LoaiPhieuFilterCtrl;
		if (!search) {
			this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiPhieu.next(
			this.listLoaiPhieu.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	isNHSX() {
		let value = + this.DNNKForm.controls["LoaiPhieu"].value;
		let item = this.listLoaiPhieu.find(x => x.Id == value)
		if (item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value;
		return false;
	}
	isNhapHangChuyenKho() {
		let item = this.listLoaiPhieu.find(x => x.Id == this.DNNKItem.LoaiPhieu)
		if (item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[3].value;
		return false;
	}
	/* -----------------------------------------------------------------------*/

	/*--------- Các hàm hỗ trợ cho thay đổi - cập nhập dữ liệu trên bảng------*/
	changeValueOfColumn(columnName: string, item: any, event: any, afterUpdate: boolean) {
		if (columnName == 'Soluongchungtu') {
			if (afterUpdate)
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Soluongchungtu = this.formatNumber(item.Soluongchungtu);
			else if (!afterUpdate) {
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Soluongchungtu = event.target.value.trim();
			}
			this.changeDetect.detectChanges();
		}

		if (columnName == 'Solo') {
			if (afterUpdate)
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Solo = item.Solo
			else if (!afterUpdate) {
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Solo = event.target.value.trim();
			}
		}

		if (columnName == 'Ghichulohang') {
			if (afterUpdate)
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Ghichulohang = item.Ghichulohang
			else if (!afterUpdate) {
				this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Ghichulohang = event.target.value.trim();
			}
		}
	}
	isChangeValueOfColumn(columnName: string, item: any) {
		if (columnName == 'Solo' && this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Solo != this.listChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Solo)
			return true;
		if (columnName == 'Soluongchungtu' && this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Soluongchungtu != this.listChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Soluongchungtu)
			return true;

		return false;
	}
	updateValueColumn(columnName: string, item: any) {
		this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
	}
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	/* -----------------------------------------------------------------------*/

	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiNhapKho.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet) {

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.f_number(event.target.value.toString());

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/

	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()) {
			this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Handung = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	dongDeNghi() {
		if (this.selection.selected.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng chọn dữ liệu cần đóng đề nghị');
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			this.deNghiNhapKhoService.dongDeNghi(this.selection.selected).subscribe(res => {
				if (res.status == 1) {
					const message = 'Cập nhật thành công';
					this.layoutUtilsService.showInfo(message);

					this.selection.selected.forEach(row => {
						row.KetQuaDuyet = 1;
					})
					this.selection.clear();
					this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	openHistoryDialog(item: DeNghiNhapKhoChiTiet) {
		const dialogRef = this.dialog.open(DNNKLSNhapKhoDialogComponent, {
			data: {
				data: item.IdCtdn,
				MaHH: item.MaHH,
				TenHH: item.TenHH
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	back() {
		this.dialogRef.close();
	}
	scrollToBottom() {
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	/* -----------------------------------------------------------------------*/
}
